import { render, staticRenderFns } from "./WizardChangeLocation.vue?vue&type=template&id=91d59438&"
import script from "./WizardChangeLocation.vue?vue&type=script&lang=js&"
export * from "./WizardChangeLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports